///<amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/documentSearch/registerTab"/>
import tabs = require("Core/Medius.Core.Web/Scripts/Medius/apps/documentSearch/tabs");

export function registerDocumentSearchTab(viewModel: any, templateId: any, label: string | number, tag: any): void {
    tabs.register(viewModel, templateId, label, tag);
}
